<template>
    <v-container fluid class="pt-4 pb-8" style="max-width: 1600px;">
        <div class="d-flex align-center mb-2" style="gap: 12px;">
            <h1 class="text-h5 font-weight-bold mb-0">Calendar</h1>
            <v-btn-toggle v-model="taskType" mandatory dense class="ml-auto">
                <v-btn value="personal" small class="text-none">My Tasks</v-btn>
                <v-btn value="assigned" small class="text-none">Assigned by Me</v-btn>
            </v-btn-toggle>
        </div>
        <ScheduleView :task-type="taskType" />
    </v-container>
</template>

<script>
import ScheduleView from './ScheduleView.vue';

export default {
    name: 'CalendarView',
    components: { ScheduleView },
    data: () => ({
        taskType: 'personal',
    }),
    mounted() {
        document.title = 'DG Tasks - Calendar';
    },
};
</script>
